import Hero from "@/sections/Hero";
import Marquee from "@/components/Marquee";
import BrandIntro from "@/sections/BrandIntro";
import OriginSection from "@/sections/OriginSection";
import ProductSection from "@/sections/ProductSection";
import QualitySection from "@/sections/QualitySection";
import HomeCTA from "@/sections/HomeCTA";
import { useLanguage } from "@/context/LanguageContext";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  const { t } = useLanguage();
  usePageMeta(t.meta.home.title, t.meta.home.desc);
  return (
    <main>
      <Hero />
      <Marquee />
      <BrandIntro />
      <OriginSection />
      <ProductSection />
      <QualitySection />
      <HomeCTA />
    </main>
  );
}
